import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
 ${({ theme }) => css`
    height: 14px; 
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    svg {
      width: 100%;
      height: 100%;
      color: ${theme?.colour?.secondary}
    }

    &:hover {
      svg {
        color: ${theme?.colour?.primary}
      }
    }
    
    @media only screen and (min-width: 768px) {
      height: 22px; 
      width: 30px;
    }
  `}
`;

export default Atom({ type: 'button', dataType: 'object', template })